import React from "react";
import { useApp } from "../../context/AppContext";
import { FONT_FAMILY, FONT_SIZES } from "../../constants/appConfig";

export const ViewLayout = ({ children }) => {
  const { palette, chapterSettings } = useApp();

  // Font scale: 85 = compact, 100 = default, 115 = large, 130 = extra large
  // Applied to the HTML root element so all rem-based FONT_SIZES scale proportionally
  const fontScale = chapterSettings?.fontScale || 100;
  React.useEffect(() => {
    document.documentElement.style.fontSize = `${fontScale}%`;
    return () => { document.documentElement.style.fontSize = ""; };
  }, [fontScale]);

  // Separate Zone 1 (header), content, and Zone 3 (footer).
  // Zone 1 and Zone 3 sit on the gradient. Content gets cardBg
  // so text1/text2/text3 are always readable regardless of palette.
  const childArray = React.Children.toArray(children);

  // Zone 1 = first child (ZoneOneHeader), Zone 3 = last child (ZoneThreeFooter)
  // Everything in between = content area with cardBg
  const zoneOne = childArray[0] || null;
  const zoneThree = childArray.length > 1 ? childArray[childArray.length - 1] : null;
  const content = childArray.slice(1, zoneThree ? childArray.length - 1 : childArray.length);

  return (
    <div style={{ height: "100vh", background: palette.background, fontFamily: FONT_FAMILY, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {zoneOne}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: palette.cardBg }}>
        {content}
      </div>
      {zoneThree}
    </div>
  );
};

export const MessageSystem = () => {
  const { messages } = useApp();
  if (!messages.length) return null;

  const colorMap = {
    success: { bg: "#dcfce7", border: "#22c55e", text: "#166534" },
    error: { bg: "#fee2e2", border: "#ef4444", text: "#991b1b" },
    warning: { bg: "#fef3c7", border: "#f59e0b", text: "#92400e" },
    info: { bg: "#dbeafe", border: "#3b82f6", text: "#1e40af" }
  };

  return (
    <div style={{ position: "fixed", top: 20, right: 20, zIndex: 9999, display: "flex", flexDirection: "column", gap: 8 }}>
      {messages.map(msg => {
        const colors = colorMap[msg.type] || colorMap.info;
        return (
          <div key={msg.id} style={{
            padding: "12px 20px", borderRadius: 10, background: colors.bg,
            borderLeft: `4px solid ${colors.border}`, color: colors.text,
            fontFamily: FONT_FAMILY, fontSize: FONT_SIZES.sm, fontWeight: 500,
            boxShadow: "0 4px 12px rgba(0,0,0,0.12)", animation: "slideIn 0.3s ease",
            maxWidth: 360
          }}>{msg.text}</div>
        );
      })}
    </div>
  );
};
